import { UsersAndUniversityDepartments } from "../../admin/data-access/models/user-information.model";
import { Faculty } from "../../admin/data-access/models/faculties-model";
import { createReducer, on } from "@ngrx/store";
import { universityProfilesActions, userProfilesActions } from "./profile-management.actions";

export interface ProfileManagementState {
  userProfiles: UsersAndUniversityDepartments;
  faculties: Faculty[];
}

const initialState: ProfileManagementState = {
  userProfiles: {
    users: [],
    departmentsAndUniversities: []
  },
  faculties: []
}

export const profileManagementReducer = createReducer(
  initialState,
  on(userProfilesActions.getUserProfilesSuccess,
    (state, { userProfiles }) => ({
      ...state,
      userProfiles: userProfiles
  })),
  on(userProfilesActions.getUserProfilesFailure,
    (state, { error }) => ({
      ...state,
      error
  })),
  on(universityProfilesActions.getFacultiesSuccess,
    (state, { faculties }) => ({
      ...state,
      faculties: faculties
  })),
  on(universityProfilesActions.getFacultiesFailure,
    (state, { error }) => ({
      ...state,
      error
  })),
)
